/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import FormBlock from 'loracoms/FormBlock';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import deviceActions from 'loraactions/device';
import { isInteger } from 'lorautils/checkers/numbers';


const propTypes = {
  params: React.PropTypes.object.isRequired,
  sent: React.PropTypes.object.isRequired,
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  getParams: React.PropTypes.func.isRequired,
  sendCmd: React.PropTypes.func.isRequired,
  getTxSize: React.PropTypes.func.isRequired,
  getMacLog: React.PropTypes.func.isRequired,
};

class RxTimingSetupReq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: new ErrorSet().add('FE_EMPTY', 'delay'),
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeDelay = this.handleChangeDelay.bind(this);
  }

  componentWillMount() {
    const { deviceId, getParams } = this.props;
    getParams(deviceId);
  }

  componentWillReceiveProps(nextProps) {
    const { params, sent } = nextProps;
    let { errors } = this.state;

    if (params !== this.props.params) {
      if (params.status === 'success') {
        const { delay } = params.data;
        this.setState({ delay });

        if (delay !== '') {
          errors = errors.remove('delay');
        }
        this.setState({ errors });
      }
    }
    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'success') {
        const { deviceId, getTxSize, getMacLog } = this.props;
        getTxSize(deviceId);
        getMacLog(deviceId);
      } else if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, 'submit');
        this.setState({ errors });
      }
    }
  }

  handleChangeDelay(e) {
    const delay = e.target.value.trim();
    this.setState({ delay });

    const { errors } = this.state;

    if (delay === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'delay') });
      return;
    }
    if (!isInteger(delay, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'delay') });
      return;
    }
    this.setState({ errors: errors.remove('delay') });
  }

  handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    const { errors } = this.state;
    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendCmd } = this.props;
    const { delay } = this.state;
    sendCmd(deviceId, { delay });
  }

  render() {
    const {
      sentStatus = '',
      delay = '',
      errors,
      submitted = false,
    } = this.state;

    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup validationState={submitted && errors.has('delay') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">Delay</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={delay}
              placeholder={this.intlMsg.msg('rxtimingsetupreq.delay.placeholder')}
              onChange={this.handleChangeDelay}
            />
            <ControlTips
              show={submitted && errors.has('delay')}
              message={this.intlMsg.errorMsg(errors.get('delay'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <RichButton
              status={sentStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('submit'),
                style: 'primary',
                type: 'submit',
              }, {
                status: 'success',
                label: this.intlMsg.msg('submit.success'),
                style: 'success',
                timer: () => this.setState({ sentStatus: '' }),
              }, {
                status: 'failure',
                label: this.intlMsg.msg('submit.failure'),
                style: 'danger',
                timer: () => this.setState({ sentStatus: '' }),
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

RxTimingSetupReq.propTypes = propTypes;

const mapStateToProps = state => ({
  params: state.device.getRxTimingSetupReq,
  sent: state.device.sendRxTimingSetupReq,
});

const mapDispatchToProps = {
  getParams: deviceActions.getRxTimingSetupReq,
  sendCmd: deviceActions.sendRxTimingSetupReq,
  getTxSize: deviceActions.getMacTxSize,
  getMacLog: deviceActions.getMacLog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(RxTimingSetupReq));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/RxTimingSetupReq.jsx